export default __webpack_public_path__ + "static/1-36-0-data-colors-f1cc626a6b37d47ebd13544295108785.png";